export const GYG365_RESTO_STORE_SECTION = 'gygStoreSectionsList'

export const GYG365_RESTO_STORE_SECTION_CREATE = 'gygStoreSectionsList/createRestoTimeslots'

export const GYG365_RESTO_STORE_SECTION_GET_ALL = 'gygStoreSectionsList/getStoreSections'

export const GYG365_RESTO_STORE_SECTION_GET_BY_ID = 'gygStoreSectionsList/getStoreSection'

export const GYG365_RESTO_STORE_SECTION_UPDATE = 'gygStoreSectionsList/updateStoreSection'

export const GYG365_RESTO_STORE_SECTION_UPSERT_MANY = 'gygStoreSectionsList/upsertManyStoreSection'

export const GYG365_RESTO_STORE_SECTION_OVERRIDE_CREATE = 'gygStoreSectionsList/createRestoTimeslotsOverride'

export const GYG365_RESTO_STORE_SECTION_OVERRIDE_GET_BY_ID = 'gygStoreSectionsList/getStoreSectionOverrideByID'

export const GYG365_RESTO_STORE_SECTION_OVERRIDE_UPDATE = 'gygStoreSectionsList/getStoreSectionOverrideUpdate'

export const GYG365_RESTO_STORE_SECTION_OVERRIDE_DELETE = 'gygStoreSectionsList/deleteStoreSectionOverride'

export const GYG365_RESTO_STORE_SECTION_OVERRIDE_BULK_DELETE = 'gygStoreSectionsList/deleteStoreSectionOverrideBulk'

export const GYG365_RESTO_STORE_ORDER_OFFSETS = 'gygStoreSectionsList/StoreOrderOffsets'

export const GYG365_RESTO_STORE_ORDER_OFFSETS_CREATE = 'gygStoreSectionsList/createOrderOffsets'

export const GYG365_RESTO_STORE_ORDER_OFFSETS_OVERRIDES = 'gygStoreSectionsList/StoreOrderOffsetsOverrides'

export const GYG365_RESTO_STORE_ORDER_OFFSETS_OVERRIDES_BY_ID = 'gygStoreSectionsList/StoreOrderOffsetsOverridesById'

export const GYG365_RESTO_STORE_ORDER_OFFSETS_UPDATE = 'gygStoreSectionsList/updateOrderOffsets'

export const GYG365_RESTO_UBER_EATS_HOURS_GET_BY_STORE_ID = 'gygStoreSectionsList/getUberEatsHoursByStoreId'

// Catering API endpoints
export const GYG365_RESTO_CATERING_GET_BY_STORE_ID = 'gygStoreSectionsList/getCateringByStoreId'

export const GYG365_RESTO_CATERING_MANAGE = 'gygStoreSectionsList/manageCatering'
